export const SCIMConfigPageDynamic = () => import('./pages/ConfigPage');
export const SCIMSetupWrapperDynamic = () => import('./pages/Setup');
export const SCIMGroupMappingDynamic = () => import('./pages/GroupMapping');
